import Component from '@glimmer/component';
import HotelStrategyChartsChartDayOfWeek from 'lumen/components/hotel/strategy/charts/chart-day-of-week';

const CHART_MARGIN_TOP = 16;

interface HotelStrategyDowTabsTabGraphSignature {
  Args: {
    params: unknown;
  };
}

export default class HotelStrategyDowTabsTabGraph extends Component<HotelStrategyDowTabsTabGraphSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get correctedChartHeight() {
    // @ts-expect-error: Incorrect type
    return this.args.params.height - CHART_MARGIN_TOP;
  }

  <template>
    <div class="mt-400">
      {{! @glint-expect-error: Incorrect type }}
      <HotelStrategyChartsChartDayOfWeek
        @containerHeight={{this.correctedChartHeight}}
        {{! @glint-expect-error: Incorrect type }}
        @data={{@params.typeData}}
        @isDetailView={{true}}
      />
    </div>
  </template>
}
